import { render } from "./YouTubeModal.vue?vue&type=template&id=06909013"
import script from "./YouTubeModal.vue?vue&type=script&lang=js"
export * from "./YouTubeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__